import styled from 'styled-components';

import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';

import { breakPoints } from '~/src/constants/breakpoints';

export const Wrapper = styled.header`
    position: relative;
    width: 100%;
    height: 578px;
    background-image: url('/static/images/center/desktop-header-img.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center bottom;
    display: flex;
    
    @media (max-width: ${breakPoints.tablet}) {
        background-image: url('/static/images/center/tablet-header-img.jpg');

        & > div {
            width: 100%;
        }
    }
    
    @media (max-width: ${breakPoints.mobile}) {
        height: 414px;
        margin-bottom: 208px;
        padding-top: 28px;
    }
    
    @media (max-width: 478px) {
        margin-bottom: 258px;
    }

    @media (max-width: 535px) {
        height: 300px;
    }
`;

export const GridContainerColumn = styled(GridContainer)`
    flex-direction: column;
`;
